<template>
    <div>
        <div class="headline">
            <h2>{{data}}</h2>
        </div>
        <div class="text-center buttons-close">
            <a @click="closeModal()">Luk</a>
        </div>
    </div>
</template>

<script>

export default {
    name: 'plain-information-modal',
    props: [
        'data'
    ],
    methods: {
        closeModal () {
            this.$emit('close')
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/shared/map/plain-information-modal.vue